import type { Mission } from '../missions.ts'

export const fsa: Mission = {
  id: "fsa",
  name: "Farm Service Agency",
  short: "FSA",
  call: "Farmers",
  kind: "subagency",
  parent: "usda",
  url: "https://www.fsa.usda.gov/",
  established: 1994,
  palette: {
    primary: "#003a63",
    secondary: "#162e51",
    accent: "#c49f06",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-FarmServiceAgency-2008Logo.svg",
  },
  motif: "wheat",
  mission: {
    text: "Farm Service Agency is equitably serving all farmers, ranchers, and agricultural partners through the delivery of effective, efficient agricultural programs for all Americans.",
    url: "https://old.fsa.usda.gov/about-fsa/history-and-mission/index",
  },
  fact: {
    text: "FSA was formed in a 1994 USDA reorganization as the Consolidated Farm Service Agency and took the name Farm Service Agency in November 1995.",
    url: "https://old.fsa.usda.gov/about-fsa/history-and-mission/agency-history/index",
  },
  seal: {
    file: "public/seals/fsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-FarmServiceAgency-2008Logo.svg",
  },
  identifier: {
    about: "https://www.fsa.usda.gov/about-fsa",
    accessibility: "https://www.usda.gov/accessibility-statement",
    foia: "https://www.fsa.usda.gov/tools/informational/freedom-information-act-foia",
    noFear: "https://www.fsa.usda.gov/about-fsa/no-fear-act",
    oig: "https://www.oig.usda.gov/",
    performance: "https://www.usda.gov/about-usda/general-information/our-performance",
    privacy: "https://www.fsa.usda.gov/about-fsa/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fsa-finney-county-wheat.jpg",
        small: "/media/fsa-finney-county-wheat-sm.jpg",
        alt: "A wheat field stretching to a flat horizon under a clear blue sky, with a dirt road edge along the right side.",
        title: "Wheat field on the high plains of Finney County, Kansas, June 6, 2022",
        creator: "Chris Thurston, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:FSA_Administrator_Kansas_Visit_(20220606-FSA-CT-0004).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
